import { useRef, useState, useEffect, useCallback, useReducer } from 'react'

export default function useImage(src) {
    const img = useRef(new Image()) //version pre SSR
    const [loaded, setLoaded] = useState(false);
    const [state, drawWhenLoaded] = useReducer(checkLoaded, loaded);
    function checkLoaded(oldState, draw) {
        //designed to properly handle scenario where img hasn't loaded yet
        //useReducer trick to avoid scoping issues that would require multiple add/removing of event listeners
        //drawWhenLoaded when called from a component will invoke this function checkLoaded, which has access to current state value for loaded
        if (!loaded) {
            img.current.addEventListener('load', draw, { once: true })
        }
        else {
            draw()
        }
        //return is irrelevant, though usually a Reducer should have one
    }

    useEffect(() => {
        img.current.src = src;
        img.current.onload = e => {
            setLoaded(true)
        }
    }, [])

    return { img: img.current, loaded, drawWhenLoaded, }; 

}